import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

export enum Collections {
  Condominiums = 'condominiums',
  Contractors = 'contractors',
  Garments = 'garments',
  Persons = 'persons',
  Laundries = 'laundries',
  LaundryCategories = 'laundry_categories',
  Lockers = 'lockers',
  Profiles = 'profiles',
  Sections = 'sections',
  Services = 'services',
  Units = 'units',
  Furnitures = 'furnitures',
  Cleanings = 'cleanings',
  Maids = 'maids_temp',
  Shops = 'shops',
  ShopGroups = 'shop_groups',
  Market = 'markets'
}

const app = initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

if (process.env.REACT_APP_ENABLE_LOCAL_EMULATOR === 'true') {
  connectFunctionsEmulator(
    functions,
    process.env.REACT_APP_FUNCTIONS_HOST!,
    Number(process.env.REACT_APP_FUNCTIONS_PORT!)
  );
}

export default app;
